import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormsModule, NgForm} from "@angular/forms";
import moment from "moment";
import {CommonModule} from "@angular/common";
import {UsersService} from "../services/users.service";
import {PrestazioneService} from "../services/prestazione.service";
import {of, switchMap} from "rxjs";
import Swal from 'sweetalert2';
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-prenotazione-create',
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './prenotazione-create.component.html',
  standalone: true,
  styleUrl: './prenotazione-create.component.css'
})
export class PrenotazioneCreateComponent implements OnInit {

  protected readonly moment = moment;
  protected dominioSito = environment.dominioSito;
  //Variabile per evitare il doppio click
  isSubmitting = false;

  //Dati della prestazione
  private prestazioneId: string = "";
  prestazione: any;
  prestazioni: any;

  //Input da form
  day: string = moment().format('YYYY-MM-DD');
  slot: any = '';
  public prenotazione = {
    prestazione: null as string | null,
    inizio: null as string | null | moment.Moment,
    fine: null as string | null | moment.Moment,
    nome: null as string | null,
    cognome: null as string | null,
    cellulare: null as string | null,
    isUser: true,
  };

  //Controlli per la validità dei campi
  public invalid = {
    slot: false,
    nome: false,
    cognome: false,
    cellulare: false,
  };

  // Elenco degli slot liberi per la prenotazione selezionata
  slots: any[] = [];

  // Controllii per la data minima e massima della prenotazione
  minDate!: string;
  maxDate!: string;

  constructor(
    public prestazioneService: PrestazioneService,
    public userService: UsersService,
    private router: Router,
    public route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    // Imposto la data minima e massima per la prenotazione
    this.minDate = moment().format('YYYY-MM-DD');
    this.maxDate = moment().add(1, 'months').format('YYYY-MM-DD');

    // Recupero la prestazione e gli slot liberi per essa
    this.route.paramMap.subscribe((paramMap) => {
      if (paramMap.has('id_prestazione')) {
        this.prestazioneId = <string>paramMap.get('id_prestazione');
        // Recupero gli slot della prestazione il giorno odierno
        this.getSlots();

        // Recupero la prestazione
        this.prestazioneService.show(this.prestazioneId).subscribe({
          next: (data) => {
            this.prestazione = data.prestazione;
            // Verifica che i dati siano validi
            if (!this.prestazione) {
              this.onErrorPrestazione();
            }
          },
          error: (err) => {
            // In caso di errore della chiamata HTTP
            console.error("Errore durante il recupero delle prestazioni:", err);
            this.onErrorPrestazione();
          }
        });

      }else{
        // Se non è valorizzato l'id va in errore e glielo fa scegliere
        this.onErrorPrestazione();
      }
    });
  }

  onErrorPrestazione() {

    console.log("Errore nella selezione della prestazione");

    this.prestazioneService.index().subscribe((data) => {
      this.prestazioni = data.prestazioni;

      // Una volta che hai le prestazioni, puoi mostrare SweetAlert
      Swal.fire({
        icon: 'error',
        title: 'Ops...',
        html: `
      <label for="prestazioneSelect">Seleziona una prestazione:</label>
      <select id="prestazioneSelect" class="input mt-2" required>
        ${this.prestazioni
          .map((p: { _id: any; nome: any; }) => `<option value="${p._id}">${p.nome}</option>`)
          .join('')}
      </select>
    `,
        confirmButtonText: 'OK',
        preConfirm: () => {
          const selectEl = document.getElementById('prestazioneSelect') as HTMLSelectElement;
          return selectEl ? selectEl.value : null;
        }
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          // Reindirizza alla rotta "create/:id" con l’_id selezionato
          this.router.navigate(['/create', result.value]);
        }
      });
    });
  }

  // Recupera le prenotazioni
  getSlots() {
    this.userService.getSlotLiberi(this.prestazioneId, this.day).subscribe((data) => {
      this.slots = data.slot;
      console.log(this.slots);
    });
  }

  //Salvo la prenotazione
  onSave(form: NgForm) {

    this.isSubmitting = true;

    if (form.invalid || this.prestazioneId == null || this.prestazione == null || this.prestazione.durata == null) {

      Swal.fire({
        icon: 'error',
        title: 'Ops...',
        text: 'Sembra che manchi qualche campo 😔 compila tutta la form',
      });

      //Eseguo i controlli sui campi da esporre a FE
      this.checkSlot();
      this.checkNome();
      this.checkCognome();
      this.checkCellulare();

      this.isSubmitting = false;

      return;
    }

    //Preparo di dati da passare al BE
    const inizio = moment(this.day + ' ' + this.slot);
    const fine = inizio.clone().add(this.prestazione.durata, 'minutes');

    // Aggiorno l'oggetto per l'inserimento della prenotazione
    this.prenotazione.prestazione = this.prestazioneId;
    this.prenotazione.inizio = inizio;
    this.prenotazione.fine = fine;

    console.log(this.prenotazione);

    // Creo la prenotazione
    this.userService.createPrenotazione(this.prenotazione)
      .pipe(
        switchMap((response) => {

          this.isSubmitting = false;

          console.log("Prenotazione creata", response);
          form.resetForm();

          Swal.fire({
            title: 'Confermata!',
            html: 'Promemoria inviato su whatsapp, se il promemoria non è arrivato assicurati di aver accettato i termini e condizioni di whatsapp <a class="font-bold text-blue-700" href="https://wa.me/tos/20210210" target="_blank">cliccando qui</a>.',
            icon: 'success',
            confirmButtonText: 'Ok',
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = this.dominioSito;
            }
          });


          return of(response);
        })
      )
      .subscribe({
        error: (error) => {
          this.isSubmitting = false;
          console.error("Errore nella creazione della prenotazione", error);
          // Controllo  i vari errori
          if(error.error.message == 'BlockList'){
            Swal.fire({
              icon: 'warning',
              title: 'Attenzione',
              html: "Non puoi effettuare prenotazioni online, chiama in negozio al 0445367239  per risolvere il problema!",
            });
          }else{
            // In base all'errore mostro messaggi diversi
            if(error.error.message == 'Errore API Whatsapp'){
              Swal.fire({
                icon: 'error',
                title: 'Attenzione',
                html: `Errore nell'invio del promemoria su whatsapp, assicurati di aver accettato i termini e condizioni di whatsapp <a class="font-bold text-blue-700" href="https://wa.me/tos/20210210" target="_blank">cliccando qui</a> e poi ripremi prenota...se l'errore persiste contatta il negozio.`,
              });
            }else{
              Swal.fire({
                icon: 'error',
                title: 'Ops...',
                html: "Errore nel salvataggio della prenotazione!" + error.error.message,
              });
            }
          }
        }
      });
  }

  checkSlot() {
    this.invalid.slot = !(this.slot != null && this.slot != "");
  }

  checkNome() {
    this.invalid.nome = !(this.prenotazione.nome != null && this.prenotazione.nome != "");
  }

  checkCognome() {
    this.invalid.cognome = !(this.prenotazione.cognome != null && this.prenotazione.cognome != "");
  }

  checkCellulare() {
    this.invalid.cellulare = !(this.prenotazione.cellulare != null && this.prenotazione.cellulare != "");
  }

}
